import React, { useEffect, useState } from 'react'
import confirmIcon from "../../assets/svg/Vector (2).svg"
import AirportShuttleOutlinedIcon from '@mui/icons-material/AirportShuttleOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import StarsOutlinedIcon from '@mui/icons-material/StarsOutlined';
import { RiCoupon3Line } from "react-icons/ri";
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router';
import { newHost } from '../../pages/Categories/CategoryProfile';

const ConfirmPayment = () => {
  const token = localStorage.getItem("token");
  const { id: orderId } = useParams()
  const [ConfirmationShow, setConfirmationShow] = useState(false)
  const [paymentDetails, setPaymentDetails] = useState(null)
  const [finalTotalPrice, setFinalTotalPrice] = useState(null)
   const handleConfirmationShow = (total) => {
    setConfirmationShow(true)
    setFinalTotalPrice(total)
  }
  const handleConfirmationClose = () => {
    setConfirmationShow(false)
  }

  const navigte = useNavigate()


  const submitPayment =  async ()=>{
     try {
      const response = await axios.get(`${newHost}stuff/confirm-payment/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      toast.success(response.data.message)
      handleConfirmationClose()
      navigte("/ordersExecution") 
    } catch (error) {
      console.log(error.response);
      toast.error(error.response?.data?.errors?.message)
    }
  }
  const getOrderSummary =  async()=>{
     try {
      const response = await axios.get(`${newHost}stuff/get-summry-for-payment/${orderId}`,{
        headers:{Authorization: `Bearer ${token}`}
      
      })
      console.log(response.data);
      
      setPaymentDetails(response.data)
     } catch (error) {
      
     }
  }
  useEffect(() => {
    getOrderSummary()
  }, [])
  
  return (
    <>
    <Modal show={ConfirmationShow} onHide={handleConfirmationClose}>
        <Modal.Header closeButton>
          <Modal.Title className='fs-4 text-center m-0 w-100'>
            تأكيد الدفع
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ direction: "rtl" }} className=''>
          <div className="mx-3 ">
            <div className="my-3 text-center">
              <h5 className='main-modal-color'>هل تم استلام المبلغ <span className="fw-bold">{`${finalTotalPrice} ج.م`}</span> من العميل؟ بعد التأكيد سيتم إغلاق الطلب نهائيًا.</h5>

            </div>


            <div className="w-100 mt-4 d-flex align-items-center gap-3">

              <button onClick={submitPayment} className="btn btn-dark px-3 w-100">تم الدفع</button>
              <button onClick={handleConfirmationClose} className="btn btn-light px-3 w-100">الغاء</button>


            </div>
            
          </div>
        </Modal.Body>
      </Modal>
      

    <div className="m-4" dir='rtl'>
      <div style={{minHeight:"75vh"}} className="">
             <div  className="w-100 d-flex justify-content-center align-items-center">
           <div className="w-100 p-3">
            <div className="text-center">
                <img src={confirmIcon} alt="" />
                <h5 className="my-2">تم انهاء الطلب بنجاح</h5>
                <p className="main-text-color my-2">في انتظار الدفع من العميل</p>
            </div>
            <div className="w-100">
                    <div style={{ backgroundColor: "#EFEFEF", }}  class="accordion-item my-3 rounded-3">
            <div class="accordion " id={`accordion-`}>
              <h2 class="accordion-header border-bottom accordion-header-responsive remove-border-focus d-flex align-items-center px-2">


                <button class="accordion-button fix-accordion-dir text-black bg-transparent d-flex justify-content-between align-items-center w-100" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-`} aria-expanded="flase" aria-controls={`collapse-`}>
                  <div className="row w-100">
                    <div className="col-8 d-flex justify-content-start">

                      ملخص الطلب
                    </div>
                    <div className="col-4 d-flex justify-content-end">

                      عرض التفاصيل
                    </div>
                  
                  </div>
                </button>



              </h2>
    <div id={`collapse-`} class="accordion-collapse collapse" data-bs-parent={`#accordion-`}>
      <div class="accordion-body shadow-sm body-accordion-profile  rounded-2">
        <div className='my-2 d-flex justify-content-between align-items-center'>
        <div className="d-flex align-items-center gap-2">
            
          <p className="m-0 text-black">اجمالي الطلبات</p>
          
        </div> 
        <div className="">
            <p className="m-0 fw-bold text-black">{`${paymentDetails?.subtotal} ج.م`}</p>
        </div>
        </div>
       <div className="">
         
        <div className='my-2 d-flex justify-content-between align-items-center'>
        <div className="d-flex align-items-center gap-2">
            <AirportShuttleOutlinedIcon sx={{transform: "scaleX(-1)"}}/>
          <p className="m-0 text-black">توصيل</p>
          
        </div> 
        <div className=""> 
            <p className="m-0 text-black fw-semibold">{`${Number(paymentDetails?.delivery) > 0 ? `  ${paymentDetails?.delivery} ج.م` : paymentDetails?.delivery}`}</p>
        </div>
        </div>
        <div className='my-2 d-flex justify-content-between align-items-center'>
        <div className="d-flex align-items-center gap-2">
           <BuildOutlinedIcon sx={{fontSize:20}} />
          <p className="m-0 text-black">خدمات لم يتم تنفيذها</p>
          
        </div> 
        <div className="">   
            <p className="m-0 text-danger fw-semibold">{`${Number(paymentDetails?.rejected_items_total) > 0 ? `- ${paymentDetails?.rejected_items_total} ج.م` : paymentDetails?.rejected_items_total}`}</p>
        </div>
        </div>
          <div className='my-2 d-flex justify-content-between align-items-center'>
        <div className="d-flex align-items-center gap-2">
           <StarsOutlinedIcon sx={{fontSize:20}} />
          <p className="m-0 text-black">{`استبدال ${paymentDetails?.points_used} نقطة`}</p>
          
        </div> 
        <div className="">
            <p className="m-0 text-danger fw-semibold">{`${Number(paymentDetails?.points_discount) > 0 ? `- ${paymentDetails?.points_discount} ج.م` : paymentDetails?.points_discount}`}</p>
        </div>
        </div>
        <div className='my-2 d-flex justify-content-between align-items-center'>
        <div className="d-flex align-items-center gap-2">
            <RiCoupon3Line sx={{transform: "scaleX(-1)"}}/>
          <p className="m-0 text-black">{`كوبون خصم (${paymentDetails?.applied_coupon.length > 0 ? `${paymentDetails?.applied_coupon[0]?.code}` : "-"})`}</p>
          
        </div>  
        <div className="">
            <p className="m-0 text-danger fw-semibold">{`${paymentDetails?.applied_coupon.length > 0 ? `${Number(paymentDetails?.applied_coupon[0]?.discount_amount) > 0 ? `- ${paymentDetails?.applied_coupon[0]?.discount_amount} ج.م` : paymentDetails?.applied_coupon[0]?.discount_amount}`: 0}`}</p>
        </div>
        </div>
       </div> 
    <div className="border-top">
        <div className='my-2 d-flex justify-content-between align-items-center py-1'>
        <div className="">
          <p className="m-0 text-black">الاجمالي</p>
          
        </div> 
        <div className="">
            <p className="m-0 fw-bold text-black">{`${paymentDetails?.final_total} ج.م`}</p>
        </div>
        </div>
    </div>
  

      </div>

    </div>
            </div>
          </div>
        
            </div>
           
           </div>
            
        </div>
  
      </div>
   <div className="w-100 d-flex justify-content-center">
              <button onClick={()=> handleConfirmationShow(paymentDetails?.final_total)} className="btn btn-dark px-5">تأكيد الدفع</button>
            </div>

    </div>
    
    </>
  )
}

export default ConfirmPayment